export default __webpack_public_path__ + "static/onze_aanpak_3-026df6f7858d092abb98bfdf06a283bf.jpg";